import Vue from 'vue'

import axios from 'axios'

// 配置请求的根路径
// axios.defaults.baseURL = 'http://192.168.1.6:18101/wxoffiacc-service/'

axios.defaults.baseURL = 'https://wxoffiacc.siguilew.com/wxoffiacc-service/'


// 请求拦截
axios.interceptors.request.use(config => {
     //请求头设置
     let token = Vue.prototype.$storageUtil.getAuthorityToken();
     if (token) {
         config.headers.AuthorityToken = token
     }
    return config
}, err => {
    console.log(err);
    return Promise.error(error);
})

// 响应拦截
axios.interceptors.response.use(response => {
    return Promise.resolve(response);
})

export const request = (obj) => {
    let method = obj.method ? obj.method.toUpperCase() == "GET" ? "GET" : "POST" : "GET";
    return axios({
        method: method,
        url: obj.url,
        data: method == "POST" ? obj.params || {} : null,
        params: method == "GET" ? obj.params || {} : null,
    }).then(res => requestSuccess(obj, res))
        .catch(err => requestFail(obj, err))
}

const requestSuccess = (obj, res) => {
    let resData = res.data;
    if (typeof resData != 'object') {
        resData = JSON.parse(resData);
    }
    return Promise.resolve(resData)
}

const requestFail = (obj, res) => {
    console.log(obj.url, ',服务器错误');
    // Vue.prototype.$dialog
    //     .alert({
    //         message: "服务请求出错",
    //         "show-cancel-button": false,
    //         "cancel-button-text": "返回",
    //         "confirm-button-text": "继续学习",
    //     })
    //     .then(() => {
    //         return Promise.resolve(res);
    //     })
    //     .catch(() => {
    //         return Promise.resolve(res);
    //     });
}




// WEBPACK FOOTER //
// ./src/utils/request.js